<template>
  <div class="section" :class="$mq">
    <div class="title">{{ $t("step2.meterType.title") }}</div>
    <div class="container inline top">
      <div
        class="frame content-centered"
        :class="{active: hasMeterType('mono')}"
        @click="setMeterType(['mono'])"
      >
        <h4>{{ $t("step2.meterType.meter-mono") }}</h4>
        <SvgIcon icon="mono" class="icon content-centered" fill />
        <div class="check-button radio"></div>
      </div>
      <div
        class="frame content-centered"
        :class="{active: hasMeterType('night')}"
        @click="setMeterType(['day', 'night'])"
      >
        <h4>{{ $t("step2.meterType.meter-tou") }}</h4>
        <SvgIcon icon="tou" class="icon content-centered" fill />
        <div class="check-button radio"></div>
      </div>
      <div
        class="frame content-centered"
        :class="{active: hasMeterType('exclusiveNight')}"
        @click="setMeterType(['exclusiveNight'])"
      >
        <h4>{{ $t("step2.meterType.meter-exclusiveNight") }}</h4>
        <SvgIcon icon="exclusiveNight" class="icon content-centered" fill />
        <div class="check-button"></div>
      </div>
      <div
        class="frame content-centered"
        :class="{active: hasSolarPanels}"
        @click="hasSolarPanels = !hasSolarPanels"
        v-if="hasElec"
      >
        <h4>{{ $t("step2.meterType.solar-panel") }}</h4>
        <SvgIcon icon="solar-panel" class="icon content-centered" fill />
        <div class="check-button"></div>
      </div>
    </div>
    <div class="container inline center margin-top" v-if="hasElec && hasSolarPanels">
      <label for="solarPannelPower">
        <h4>{{ $t("step2.meterType.solar-panel-power") }}</h4>
        <ValidationProvider
          rules="required|numeric|max_value:20|min_value:1"
          v-slot="{ errors }"
          :customMessages="{ required: $t('step2.meterType.solar-power-required'),
          max_value: $t('step2.meterType.solar-power-max'),
          min_value: $t('step2.meterType.solar-power-min'),
           }"
        >
          <input
            type="number"
            step="1"
            id="solarPannelPower"
            name="solarPannelPower"
            class="input"
            v-model="solarPanelsPower"
          />
          <span class="input-error">{{ errors[0] }}</span>
        </ValidationProvider>
      </label>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  computed: {
    ...mapState("consumption", ["meterType", "consumptions"]),
    ...mapGetters("energy", ["hasElec", "hasGas"]),
    hasSolarPanels: {
      get() {
        return this.$store.state.consumption.hasSolarPanels;
      },
      set(value) {
        this.$store.commit("consumption/setHasSolarPanels", value);
      }
    },
    solarPanelsPower: {
      get() {
        return this.$store.state.consumption.solarPanelsPower;
      },
      set(value) {
        this.$store.commit("consumption/setSolarPanelsPower", value);
      }
    }
  },
  methods: {
    hasMeterType(meterType) {
      return this.meterType.indexOf(meterType) !== -1;
    },
    setMeterType(meterType) {
      let meterTypes = [];

      if (meterType.indexOf("exclusiveNight") === -1) {
        meterTypes = meterType.filter(meterType => meterTypes !== 'gas');
        if (this.hasGas) meterTypes.push("gas");
      } else {
        meterTypes = this.meterType;

        let index = meterTypes.indexOf("exclusiveNight");

        if (index === -1) {
          meterTypes.push("exclusiveNight");
        } else {
          meterTypes.splice(index, 1);
        }
      }
      
      this.$store.commit("comparison/reset");
      this.$store.commit("consumption/setValid", false);
      this.$store.commit("consumption/setMeterType", meterTypes);
    }
  }
};
</script>

<style lang="scss" scoped>
.input-error {
  max-width: 250px;
}
</style>



// WEBPACK FOOTER //
// src/views/consumption/MeterType.vue